import { DataSender } from '../loaders'
/**
* ManageTickets
*/

class ManageTickets {
    constructor(options) {
        this.texts = options.texts;

        this.view = $('section.manage-tickets');
        this.soldTicketsBox = this.view.find('div.sold-tickets');

        if(this.soldTicketsBox.length) {
            this.soldTicketsTable = this.view.find('table#sold-tickets');
            this.initTable();
        }
    }

    initTable() {
        var that = this;

        this.soldTicketsTable.find('input.circular').bind('change', function() {
            var checkbox = $(this);
            var dateCell = checkbox.parent().parent().parent().find('td:last-child');
            var dateCellValue = dateCell.text();

            dateCell.html('<div class="activity-indicator gray"></div>');

            if($(this).is(':checked')) {
                new DataSender({
                    data: {
                        action: 1,
                        id: checkbox.val()
                    },
                    url: '/event/tickets/check/',

                    success: function(data) {
                        if(data.status) {
                            checkbox.prop('checked', true);
                            dateCell.text(data.date);
                        }
                    },

                    error: function() {
                        checkbox.prop('checked', false);
                        dateCell.text(dateCellValue);
                    }
                });
            }
            else {
                if(window.confirm(that.texts.uncheckConfirm)) {
                    new DataSender({
                        data: {
                            action: 0,
                            id: checkbox.val()
                        },
                        url: '/event/tickets/check/',

                        success: function(data) {
                            if(data.status) {
                                checkbox.prop('checked', false);
                                dateCell.text('-');
                            }
                        },

                        error: function() {
                            checkbox.prop('checked', true);
                            dateCell.text(dateCellValue);
                        }
                    });
                }
                else {
                    checkbox.prop('checked', true);
                    dateCell.text(dateCellValue);
                }
            }
        });

        // DataTable order:
        $.fn.dataTable.ext.order['name-order'] = function(settings, col) {
            return this.api().column(col, { order: 'index' }).nodes().map(function(td, i) {
                return $(td).data('name');
            });
        }

        $.fn.dataTable.ext.order['price-order'] = function(settings, col) {
            return this.api().column(col, { order: 'index' }).nodes().map(function(td, i) {
                return $(td).data('price');
            });
        }

        $.fn.dataTable.ext.order['date-order'] = function(settings, col) {
            return this.api().column(col, { order: 'index' }).nodes().map(function(td, i) {
                return $(td).data('date');
            });
        }

        $.fn.dataTable.ext.order['used-order'] = function(settings, col) {
            return this.api().column(col, { order: 'index' }).nodes().map(function(td, i) {
                return $('input[type="checkbox"]', td).prop('checked') ? 1 : 0;
            });
        }

        // DataTable:
        this.soldTicketsTable.dataTable({
            columns: [
                null,
                { 'orderDataType': 'name-order', type: 'numeric' },
                { orderable: false },
                { 'orderDataType': 'price-order', type: 'numeric' },
                null,
                null,
                { 'orderDataType': 'date-order', type: 'numeric' },
                { 'orderDataType': 'used-order', type: 'numeric' },
                { 'orderDataType': 'date-order', type: 'numeric' }
            ],
            language: globalTexts.dataTables.texts,
            lengthMenu: [
                [ 10, 25, 50, 100, -1 ],
                [ 10, 25, 50, 100, globalTexts.dataTables.allRecords ]
            ],
            order: [[ 7, 'asc' ]],
            stateSave: true
        });

        this.soldTicketsTable.bind('draw.dt', function() {
            if(that.toggleInformation.length) {
                if(that.toggleInformation.is(':checked')) {
                    that.showInformation();
                }
                else {
                    that.hideInformation();
                }
            }
        });

        this.soldTicketsBox.find('select').addClass('rounded');
        this.soldTicketsBox.find('input').addClass('rounded').prop('placeholder', globalTexts.dataTables.inputPlaceholder).parent().get(0).firstChild.nodeValue = '';

        // Toggle information:
        this.toggleInformation = $('input#toggle-information');
        this.toggleInformation.bind('change', function() {
            if(!that.toggleInformation.is(':checked')) {
                that.hideInformation();
            }
            else {
                that.showInformation();
            }
        });
    }

    hideInformation() {
        this.soldTicketsTable.find('ul.token-list').each(function() {
            $(this).addClass('hidden');
            $(this).parent().removeClass('padding');
        });
    }

    showInformation() {
        this.soldTicketsTable.find('ul.token-list').each(function() {
            $(this).removeClass('hidden');
            $(this).parent().addClass('padding');
        });
    }
}

export { ManageTickets }
